import React, { useEffect } from "react";

import Api from "app/js/api.ts";
import Header from "app/components/Header/Header.tsx";
import Box from "app/components/Box/Box.tsx";
import Button from "app/components/Buttons/Button.tsx";
import FormComponent from "app/components/FormComponent/FormComponent.tsx";
import ErrorMessage from "app/components/ErrorMessage/ErrorMessage.tsx";

import styles from "./Settings.scss";

import { useSafeState } from "app/js/hooks";
import { useUserStore } from "app/js/stores";

export default function CreateTeam({ history }) {
  const [user, userActions] = useUserStore();

  const [team, setTeam] = useSafeState({ name: "" });
  const [error, setError] = useSafeState(null);

  const handleChangeTeamName = (e) => {
    setTeam({ ...team, name: e.target.value });
  };

  const handleTeamCreate = async (event) => {
    event.preventDefault();
    setError(null);

    if (team.name) {
      try {
        var response = await Api.team().store(team);
        userActions.setTeam(response.data.data);
        setError(null);
      } catch (e) {
        setError(e);
      }
    } else {
      setError("Please enter a team name.");
    }
  };

  return (
    <div>
      <Header showCreate={false}>
        <h1>Create Team</h1>
      </Header>
      <div className={styles.content}>
        <form onSubmit={handleTeamCreate}>
          <Box title="Create Team">
            <ErrorMessage error={error} />
            <FormComponent>
              <label htmlFor="teamName">Team Name</label>
              <input
                type="text"
                name="teamName"
                value={team.name}
                onChange={handleChangeTeamName}
              />
            </FormComponent>
            <Button>Create</Button>
          </Box>
        </form>
      </div>
    </div>
  );
}
